import styled from 'styled-components';
import Text12 from '@sdk/components/ui/typography/Text12';
import Column from '@sdk/components/ui/spacing/Column';

import InfoIconSvg from '../../../assets/svg/Icons/16/info-gray.svg';

export const Plan = styled(Column)`
  flex: 2;
`;

export const InfoIcon = styled(InfoIconSvg)`
  margin-left: 5px;
`;

export const DiscountInfo = styled(Text12)`
  margin-left: auto;
`;
